import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	DISCARD_PAYMENT_MODAL__BODY_TEXT_TITLE,
	DISCARD_PAYMENT_MODAL__CANCEL,
	DISCARD_PAYMENT_MODAL__SUBMIT,
	DISCARD_PAYMENT_MODAL__TITLE,
} from '../data/constants';

interface DiscardPaymentModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const DiscardPaymentModal = (props: DiscardPaymentModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{DISCARD_PAYMENT_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{DISCARD_PAYMENT_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{DISCARD_PAYMENT_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained' color='error'>
					{DISCARD_PAYMENT_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DiscardPaymentModal;
